import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  artLaboratory,
  btechCseProgram,
  campusLife,
  careerOpportunities,
  cdgiHighlights,
  learningApproach,
  researchAndInnovation,
  subfieldsOfAIAndML,
  subfieldsOfCloudComputingAndDevops,
  subfieldsOfCybersecurity,
  subfieldsOfDataScienceAndAnalytics,
} from "./constant";
import "./computer_science_and_engineering.css";
import Faq from "./Faq";
import { CreateStudentEnquirey } from "../../../api/Global";
import { Modal } from "react-bootstrap";

const Computer_Science_And_Engineering = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);

  const navigate = useNavigate();
  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [course, setCourse] = useState("");
  const [mathAnswer, setMathAnswer] = useState("");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [courseError, setCourseError] = useState("");
  const [sumAnswerError, setsumAnswerError] = useState("");

  const HandleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setMobileError("");
    setCityError("");
    setEmailError("");
    setCourseError("");
    setsumAnswerError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!name.trim()) return setNameError("Name is required!");

    if (!email.trim()) return setEmailError("Email is required!");
    if (!emailRegex.test(email.trim()))
      return setEmailError(
        "Please provide a correct email, invalid email format!"
      );

    if (!mobile.trim()) return setMobileError("Mobile number is required!");
    if (!indianMobileRegex.test(mobile.trim()))
      return setMobileError("Invalid mobile number format");
    if (!city.trim()) return setCityError("City is required!");

    if (!course.trim()) return setCourseError("Course is required!");

    if (!mathAnswer.trim()) return setsumAnswerError("Please add the sum!");
    if (mathAnswer.toString() !== "14")
      return setsumAnswerError("Please add and put the correct value");
    const data = {
      name,
      email,
      mobile,
      email,
      city,
      course,
      mathAnswer,
    };
    try {
      const response = await CreateStudentEnquirey(data);

      if (response?.data?.status == true) {
        navigate("/Thank_You");
        setName("");
        setEmail("");
        setMobile("");
        setCity("");
        setCourse("");
        setMathAnswer("");
        setShow(false);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleShowContent = () => {
    setShowMoreContent(!showMoreContent);
  };

  return (
    <div className="main-container">
      {/*  modal code [admission form] */}

      <Modal
        size="lg"
        className="asmission_enquiry"
        show={showModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center"
            style={{
              textAlign: "center",
              width: "100%",
              color: "#007bff",
            }}
          >
            Admission Enquiry Form
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white p-2 p-lg-5">
            <div className="modlaPopup">
              <div className="elementor-widget-container">
                <form className="wpcf7-form">
                  <div className="form-group mb-3">
                    <label>Your Name</label>
                    <input
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      name="name"
                      value={name}
                    />
                    {nameError && <p className="text-danger">{nameError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Your Email</label>
                    <input
                      className="form-control"
                      placeholder="Email ID"
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      name="email"
                      value={email}
                    />
                    {emailError && <p className="text-danger">{emailError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Mobile Number</label>
                    <input
                      className="form-control"
                      placeholder="Phone"
                      onChange={(e) => setMobile(e.target.value)}
                      type="number"
                      name="mobile"
                      value={mobile}
                    />
                    {mobileError && (
                      <p className="text-danger">{mobileError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>City</label>
                    <input
                      className="form-control"
                      placeholder="City"
                      onChange={(e) => setCity(e.target.value)}
                      type="text"
                      name="city"
                      value={city}
                    />
                    {cityError && <p className="text-danger">{cityError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Course</label>
                    <select
                      className="form-control"
                      required
                      name="course"
                      value={course}
                      onChange={(e) => setCourse(e.target.value)}
                    >
                      <option value="">Please select Any Course</option>
                      <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">
                        Engineering Courses [CS, IT, AI & DS, CSIT]
                      </option>
                      <option value="B.Tech. Course [EC]">
                        Engineering Course [Electronics & Comm. Engg.]
                      </option>
                      <option value="B.Tech. Course [ME]">
                        Engineering Course [Mechanical Engineering]
                      </option>
                      <option value="B.Tech. Course [Civil Engg.]">
                        Engineering Course [Civil Engineering]
                      </option>
                      <option value="Pharmacy Courses[B.Pharm, D.Pharm]">
                        Pharmacy Courses [B.Pharm, D.Pharm]
                      </option>
                      <option value="Pharmacy Course[M.Pharm]">
                        Pharmacy Course [M.Pharm]
                      </option>
                      <option value="Management Courses[MBA(FT,MM,FA)]">
                        Management Courses [MBA(FT,MM,FA)]
                      </option>
                      <option value="Professional Course [BBA]">
                        Professional Courses [BBA]
                      </option>
                      <option value="Professional Course[BCA]">
                        Professional Courses [BCA]
                      </option>
                      <option value="Professional Course[B.Com]">
                        Professional Courses [B.Com]
                      </option>
                      <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                        Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                      </option>
                      <option value="MCA Course">MCA Course</option>
                    </select>
                    {courseError && (
                      <p className="text-danger">{courseError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>What is nine plus five?</label>
                    <input
                      className="form-control"
                      placeholder="Answer"
                      onChange={(e) => setMathAnswer(e.target.value)}
                      type="text"
                      name="mathAnswer"
                      value={mathAnswer}
                    />
                    {sumAnswerError && (
                      <p className="text-danger">{sumAnswerError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3 text-center">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      onClick={HandleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className="main-top-container">
        <p>Top Engineering Colleges for Computer Science Engineering</p>

        <p className="container-description">
          Chameli Devi Group of Institutions (CDGI) is widely recognized as one
          of the{" "}
          <Link to={"/"}>
            {" "}
            <span className="text-hover-blue-underline">
              top engineering colleges for computer science engineering in
              Indore
            </span>{" "}
          </Link>{" "}
          and central India. For students and parents seeking a future-ready,
          industry-aligned education, CDGI offers an ideal combination of
          academic rigor, practical training, and placement opportunities. With
          NAAC A+ accreditation, AICTE approval, and affiliation to RGPV Bhopal,
          our Computer Science & Engineering (CSE) program is tailored to meet
          the demands of the global tech industry.
          <br />
          CDGI is committed to nurturing not just engineers but problem solvers,
          innovators, and responsible digital citizens who are equipped to
          thrive in a dynamic technology-driven world.
        </p>
      </div>

      <div className="why-cdgi">
        <h2 className="container-title-h2">
          Why CDGI is Among the Top Engineering Colleges for Computer Science
          Engineering
        </h2>
        <p className="container-description">
          For students planning a career in the technology sector, choosing the
          right engineering college is crucial. CDGI offers a comprehensive
          B.Tech program in Computer Science Engineering that blends strong
          academic foundations with the latest technological advancements.
        </p>
      </div>

      {showMoreContent && (
        <>
          <div className="cdgi-highlights-conatiner">
            <h3 className="container-title-h3">CDGI Highlights</h3>
            <div>
              {cdgiHighlights.map((highlight, ind) => (
                <ul>
                  <li key={ind}> {highlight}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="overview-container">
            <h3 className="container-title-h3">
              Overview of the Computer Science Engineering Department
            </h3>

            <p>
              At CDGI, the Department of Computer Science & Engineering is
              dedicated to producing industry-ready professionals. For both
              students and parents, it's important to know that our curriculum
              is designed with practical skill development and innovation at its
              core.
            </p>
          </div>

          <div className="btech-program-container">
            <p>What You'll Learn</p>
            <p>Our B.Tech CSE program covers:</p>

            <div>
              {btechCseProgram.map((program, ind) => (
                <ul>
                  <li key={ind}>{program}</li>
                </ul>
              ))}
            </div>
            <div className="state-container">
              <p>State-of-the-Art Laboratories</p>
              <p>Students gain hands-on experience in:</p>
              <div>
                {artLaboratory.map((program, ind) => (
                  <ul>
                    <li key={ind}>{program}</li>
                  </ul>
                ))}
              </div>
            </div>
          </div>

          <div className="courses-conatiner">
            <h3 className="container-title-h3">
              Specialized Tracks in Computer Science Engineering
            </h3>
            <p className="container-description">
              To ensure students are aligned with industry trends, CDGI offers
              multiple specialization tracks within the CSE program:
            </p>

            <div>
              <h4 className="container-title-h4">AI & Machine Learning</h4>

              {subfieldsOfAIAndML.map((field, ind) => (
                <ul>
                  <li key={ind}>{field}</li>
                </ul>
              ))}
            </div>

            <div>
              <h4 className="container-title-h4">Cloud Computing & DevOps</h4>

              {subfieldsOfCloudComputingAndDevops.map((field, ind) => (
                <ul>
                  <li key={ind}>{field}</li>
                </ul>
              ))}
            </div>

            <div>
              <h4 className="container-title-h4">Cybersecurity</h4>

              {subfieldsOfCybersecurity.map((field, ind) => (
                <ul>
                  <li key={ind}>{field}</li>
                </ul>
              ))}
            </div>

            <div>
              <h4 className="container-title-h4">Data Science & Analytics</h4>

              {subfieldsOfDataScienceAndAnalytics.map((field, ind) => (
                <ul>
                  <li key={ind}>{field}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="career-container">
            <h3 className="container-title-h3">
              Career Opportunities After Computer Science Engineering
            </h3>
            <p className="container-description-sp">
              One of the key reasons CDGI is considered among the top
              engineering colleges for computer science engineering is its focus
              on career preparation. Our students are equipped for roles such
              as:
            </p>

            <div>
              {careerOpportunities.map((career) => (
                <ul>
                  <li>{career}</li>
                </ul>
              ))}
            </div>
          </div>

          <p className="graduate-student">
            • Graduates also pursue higher education and research in India and
            abroad, or launch their own tech start-ups.
          </p>

          <div className="campus-container">
            <p className="">Campus Life for CSE Students</p>
            <p>
              CDGI offers a vibrant campus experience for holistic development:
            </p>
            <div>
              {campusLife.map((campusLife) => (
                <ul>
                  <li>{campusLife}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="faculty-container">
            <p>Faculty and Mentors</p>
            <p className="container-description">
              CDGI’s CSE faculty includes Ph.D. holders, researchers, and
              industry-certified professionals who guide students through:
            </p>
            <div>
              {learningApproach.map((learning, index) => (
                <ul>
                  <li key={index}>{learning}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="research-and-innovation-container">
            <p>Research, Innovation & Entrepreneurship</p>
            <p className="container-description">
              Students are encouraged to think innovatively and solve real-world
              problems. Our CSE department actively promotes:
            </p>
            <div>
              {researchAndInnovation.map((item, index) => (
                <ul>
                  <li key={index}>{item}</li>
                </ul>
              ))}
            </div>
          </div>
          <div className="admission-container">
            <h4 className="container-title-h4">
              Admission Process for CSE at CDGI
            </h4>

            <div>
              <p className="eligibility-text">Eligibility Criteria:</p>
              <p>• 10+2 with Physics, Chemistry, and Mathematics</p>
              <p>• Qualifying entrance exam (JEE Main / State-level CET)</p>
            </div>
          </div>
          <div className="apply-now-container">
            <p className="application-step-text">Application Steps:</p>
            <p>
              • Click{" "}
              <span className="text-hover-blue-underline" onClick={openModal}>
                Apply Now{" "}
              </span>
            </p>
          </div>
          <Faq />
        </>
      )}

      <div
        className="btn-container"
        style={{
          marginBottom: "100px",
        }}
      >
        <button
          style={{
            all: "unset",
            textAlign: "center",
            borderRadius: "3px",
            backgroundColor: "#004b9c",
            color: "white",
            cursor: "pointer",
            marginTop: "10px",
            marginLeft: "40px",
            padding: "0 10px",
          }}
          onClick={handleShowContent}
        >
          {showMoreContent ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

export default Computer_Science_And_Engineering;
